import React from 'react';
import TutorProfileComponent from '../../components/TutorProfileComponent';
import withAuth from '../../withAuth';
import { Container, Box, Button, Stack } from '@mui/material';
import { Logout as LogoutIcon, DeleteForever as DeleteIcon } from '@mui/icons-material';
import { useVerifyEmail } from '../../hooks/useVerifyEmail';
import { useLogin } from '../../hooks/useLogin';

const Profile: React.FC = () => {
  const { handleDeleteAccount } = useVerifyEmail();
  const { logout } = useLogin();

  return (
    <Container component="main" maxWidth="md" sx={{ mb: 4 }}>
      <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <TutorProfileComponent />

        <Stack direction="row" spacing={2} sx={{ mt: 4 }}>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<LogoutIcon />}
            onClick={logout}
            data-testid="profile-logout-button"
          >
            Logout
          </Button>
          <Button
            variant="contained"
            color="error"
            startIcon={<DeleteIcon />}
            onClick={handleDeleteAccount}
            data-testid="profile-delete-button"
          >
            Delete Account
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default withAuth(Profile);
